module.exports = __webpack_public_path__ + "img/cnn-sia.66a80434.jpg";